<template>
  <div class="flex items-center gap-2">
    <progress :value="percent" max="100">({{ percent }}%)</progress>
    <span class="text-sm">({{ percent }}%)</span>
  </div>
</template>
<script setup lang="ts">
defineProps<{ percent: number }>();
</script>
<style scoped>
.progress-bar__wrapper {
  position: relative;
}
.progress-bar__value {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
progress {
  width: 100%;
  height: 8px;
  border-radius: 50px;
  background-color: #eee;
  transition: width 300ms ease;
}
progress[value]::-webkit-progress-bar {
  width: 100%;
  height: 8px;
  border-radius: 50px;
  background-color: #eee;
  transition: width 300ms ease;
}
progress[value]::-webkit-progress-value {
  background-color: var(--color-primary-500);
  width: 0;
  border-radius: 50px;
  transition: width 300ms ease;
}
</style>
